import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import {storeGraph} from '@/store/StoreGraph';
import {storeUI} from '@/store/StoreUI';
// import Util from '@/common/Util';

Vue.use(Vuex);

const persistTasker = new VuexPersist({
  key: 'Tasker', //need to do something clever so that multiple Taskers can co-exist...later
  // key: 'Tasker' + Util.uuidv4(),
  storage: window.localStorage, //https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API
  modules: ['graph']
});


export default new Vuex.Store({
  plugins: [persistTasker.plugin],
  modules: {
    graph: storeGraph,
    ui: storeUI
  }
});
